<template>
  <RsModal
    :value="value"
    :title="$ts('tipTap.editContent')"
    button-text="Ok"
    size="xl"
    is-centered
    no-close-on-backdrop
    dialog-class="rs-modal-tiptap-full-screen"
    @input="$emit('input', $event)"
    @submit="handleSubmit"
  >
    <RsFormTipTap
      id="tiptap_full_screen"
      ref="editor"
      :value="content"
      :format="format"
      is-full-screen
      height="65vh"
    />
  </RsModal>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { assertRef } from '@/shared/helpers/assert-ref';
import RsFormTipTap from './_global/RsFormTipTap.vue';
import { TTipTapFormat } from '@/shared/tiptap/types';

/**
 * Mostly for use with quill editor, but this modal is just for editing HTML content passed via `html` prop.
 * @emits submit with the updated HTML content.
 */
export default defineComponent({
  props: {
    value: {
      type: Boolean,
      required: true,
    },

    content: {
      type: String,
      default: '',
    },

    format: {
      type: String as PropType<TTipTapFormat>,
      required: true,
    },
  },

  methods: {
    handleSubmit() {
      const newContent = assertRef(this.$refs.editor, RsFormTipTap).getHTML(false);
      this.$emit('submit', newContent);
    },
  },
});

</script>

<style lang="scss">
.rs-modal-tiptap-full-screen {
  width: 90% !important;
  max-width: 90% !important;
}
</style>
